/**
 * @generated SignedSource<<96759f58028e86a8ff8d7ebc378a340d>>
 * @relayHash b41cf629208c69eb2e1533d741a479ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b96fcf0cbb5b600a9fce1e81b438e97c3e32beb20189a2909f49d16d5578b7e9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassicPortalSettingsQuery$variables = {
  cloudId: string;
  cloudIdString: string;
};
export type ClassicPortalSettingsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PortalSettings">;
};
export type ClassicPortalSettingsQuery = {
  response: ClassicPortalSettingsQuery$data;
  variables: ClassicPortalSettingsQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider": extractRovoAgentConfigurationPackageFG_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider: {
    readonly get: () => boolean;
  };
});

import extractRovoAgentConfigurationPackageFG_provider from '@atlassian/jira-relay-provider/src/extract-rovo-agent-configuration-package.relayprovider';
import rovoAgentConfigExperienceFG_provider from '@atlassian/jira-relay-provider/src/jsm-portal-rovo-agent-config-experience.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudIdString"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyEditableAgents": true
    }
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "args": (v3/*: any*/),
  "concreteType": "AgentStudioAgentsConnection",
  "kind": "LinkedField",
  "name": "agentStudio_getAgents",
  "plural": false,
  "selections": [
    {
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hasNextPage"
        },
        {
          "kind": "ScalarField",
          "name": "endCursor"
        }
      ]
    },
    {
      "concreteType": "AgentStudioAgentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "AgentStudioAssistant",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "externalConfigReference"
            },
            {
              "kind": "ScalarField",
              "name": "identityAccountId"
            },
            {
              "kind": "ScalarField",
              "name": "creatorType"
            },
            (v4/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "cursor"
        }
      ]
    }
  ]
},
v6 = {
  "args": (v3/*: any*/),
  "filters": [
    "cloudId",
    "input"
  ],
  "handle": "connection",
  "key": "RovoAgent_agentStudio_getAgents",
  "kind": "LinkedHandle",
  "name": "agentStudio_getAgents"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ClassicPortalSettingsQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "cloudIdString",
            "variableName": "cloudIdString"
          }
        ],
        "kind": "FragmentSpread",
        "name": "PortalSettings"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ClassicPortalSettingsQuery",
    "selections": [
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      },
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "args": [
              (v2/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "atlassianStudio_userSiteContext",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AtlassianStudioUserProductPermissions",
                    "kind": "LinkedField",
                    "name": "userPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                      }
                    ]
                  }
                ],
                "type": "AtlassianStudioUserSiteContextOutput"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b96fcf0cbb5b600a9fce1e81b438e97c3e32beb20189a2909f49d16d5578b7e9",
    "metadata": {},
    "name": "ClassicPortalSettingsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider": extractRovoAgentConfigurationPackageFG_provider
    }
  }
};
})();

(node as any).hash = "f6bb257b47e1fe1b359c1df932c2a29f";

export default node;
